import axios from 'axios';
import {
    msg,
    openLoding,
    closeLoding
} from './common';

// config設定
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 10000, // request timeout
    withCredentials: true
});

// request interceptor
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        // do something with request error
        msg("連線失敗", 3000);
        return Promise.reject(error);
    }
);

// Add a response interceptor
service.interceptors.response.use(({
    data
}) => {
    closeLoding();
    return data;
}, (error) => {
    closeLoding();
    if(error.message.includes('timeout')) {
        msg('連線超時，請重新整理', 3000);
    } else{
        switch (error.response.status) {
            case 400: {
                msg('參數錯誤!!', 3000);
                break;
            }
            default: {
                msg(error.response.data, 3000);
                break;
            }
        }
    }
    return Promise.reject(error);
});

export function dbio(url, data, method = 'get') {
    openLoding();
    if (method === 'get') {
        return service({
            url,
            method: 'get',
            params: data
        });
    } else if (method === 'post') {
        return service({
            url,
            method: 'post',
            data
        });
    }
    return null;
}